import { render } from "./ServiceTaskRow.vue?vue&type=template&id=066a4733&ts=true"
import script from "./ServiceTaskRow.vue?vue&type=script&lang=ts"
export * from "./ServiceTaskRow.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__